var _path, _circle;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
import { forwardRef } from "react";
const SvgFacebookIcon = (_ref, ref) => {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 24 24",
    ref: ref,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M12.001 20.829a9 9 0 119-9 9.01 9.01 0 01-9 9zM8.883 10.15v2.132h1.845v5.547h2.2v-5.547h1.838l.274-2.131h-2.111V8.787c0-.622.18-1.037 1.057-1.037h1.13V5.842a15.077 15.077 0 00-1.646-.086 2.582 2.582 0 00-2.742 2.822v1.572z",
    fill: "#fff"
  })), _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 12,
    cy: 12,
    r: 12,
    fill: "rgba(255,255,255,.3)",
    opacity: 0.65
  })));
};
const ForwardRef = /*#__PURE__*/forwardRef(SvgFacebookIcon);
export { ForwardRef as ReactComponent };
export default __webpack_public_path__ + "static/media/facebook_icon.819692345290b9bebe8159f95fc22eaf.svg";